import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GroupPosition } from '../../stock-levels-model/stock-levels-modal.component';
import { PigeonholeDetails } from 'src/models/Pigeonhole';
import { UserRoles } from 'src/models/User';
import { MatDialog } from '@angular/material/dialog';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';
import { SnackBarService } from 'src/app/core/services/snack-bar.service';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-pigeonhole-details',
  templateUrl: './pigeonhole-details.component.html',
  styleUrls: ['./pigeonhole-details.component.scss']
})
export class PigeonholeDetailsComponent implements OnInit {
  @Input() group: GroupPosition = {
    id: '',
    name: '',
    type: '',
    levelsEnabled: false
  };
  @Input() position: PigeonholeDetails;
  @ViewChild('notification', { static: true }) notificationTmpl;
  notificationData: { type: string; title: string; message: string; };
  userRole: UserRoles = null;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private actionService: ActionService,
    private errorService: ErrorService,
    private snackBarService: SnackBarService
  ) { }

  ngOnInit() {
    this.userRole = this.route.snapshot.firstChild.data.role;
  }

  isAllowedUser() {
    return this.userRole === UserRoles.MASTER || this.userRole === UserRoles.ADMIN;
  }

  async removePigeonhole() {
    this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: {
        label: `Você tem certeza que deseja excluir a posição ${this.position.coords}?\nEsta ação não pode ser desfeita.`,
        confirmBtnClass: 'alert'
      }
    }).afterClosed().subscribe(deleteConfirmed => {
      if (deleteConfirmed) {
        this.confirmRemovePigeonhole();
      }
    });
  }

  async confirmRemovePigeonhole() {
    try {
      await this.actionService.removePigeonhole({ id: this.position.id });
      this.notifySuccess();
    } catch (err) {
      this.handleError(err);
    }
  }

  notifySuccess() {
    this.notificationData = {
      type: 'success',
      title: 'Posição excluída com sucesso!',
      message: `A posição ${this.position.qrCode} foi excluída com sucesso.`
    };
    const notificationId = 'remove-pigeonhole-success';
    this.snackBarService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
    setTimeout(() => {
      this.snackBarService.hideNotification(notificationId);
      location.reload();
    }, 5000);
  }

  handleError(err) {
    const error = err?.error?.body;
    if (!error || !error.type) return;

    switch (error.type) {
      case ErrorsEnum.PIGEONHOLE_NOT_FOUND:
        this.errorService.openErrorSnackBarWithCustomMessage(`Posição não encontrada.`);
        break;
      case ErrorsEnum.PIGEONHOLE_WITH_PACKAGES:
        this.errorService.openErrorSnackBarWithCustomMessage(
          `Não é permitido excluir posições ocupadas por pacotes. Esvazie a posição e tente novamente.`
        );
        break;
    }
  }

}
